import { ComplementaryServiceComponent } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/additional-info/_components/complementary-service-component";
import { TravelInfoComponent } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/additional-info/_components/travel-info-component";
import { PestsComponent } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/additional-info/_components/pests-component";
import { CycleComponent } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/additional-info/_components/cycle-component";
import { CertificatesComponent } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/additional-info/_components/certificates-component";
import { AdditionalCommentsComponent } from "@/routes/processes/[processId]/qpm/requirements/[requirementId]/additional-info/_components/additional-comments-component";
import { RequirementAdditionalInformation } from "@/services/backend/qpm/requirements/types/requirement";
import {
  useRequirementData,
  useRequirementEdit,
} from "@/services/backend/qpm/requirements/hooks/requirement-context";
import { Loader2 } from "lucide-react";
import { RequirementDTO } from "@/services/backend/qpm/requirements/types/requirement-dto";

export function AdditionalInfoRoute() {
  const { isLoading } = useRequirementData();
  const { putRequest: requirement } = useRequirementEdit();

  if (isLoading) {
    return <Loader2 className="animate-spin" />;
  }

  return (
    requirement && (
      <AdditionalInfoComponent requirement={requirement.requirement} />
    )
  );
}

export type AdditionalInfoComponentProps = {
  requirement: RequirementDTO;
};

export function AdditionalInfoComponent({
  requirement,
}: AdditionalInfoComponentProps) {
  const { updateRequirement } = useRequirementEdit();

  const updateAdditionalInfoState = (
    updatedInfo: Partial<RequirementAdditionalInformation>,
  ) => {
    updateRequirement((prev) => ({
      additionalInformation: {
        ...prev.additionalInformation,
        ...updatedInfo,
      },
    }));
  };

  return (
    <div className="flex flex-col">
      <ComplementaryServiceComponent
        additionalInformation={requirement.additionalInformation}
        onUpdate={updateAdditionalInfoState}
      />
      <TravelInfoComponent
        additionalInformation={requirement.additionalInformation}
        onUpdate={updateAdditionalInfoState}
      />
      <PestsComponent requirement={requirement} />
      <CycleComponent
        additionalInformation={requirement.additionalInformation}
        onUpdate={updateAdditionalInfoState}
      />
      <CertificatesComponent
        additionalInformation={requirement.additionalInformation}
        customerId={requirement.customerId}
        onUpdate={updateAdditionalInfoState}
      />
      <AdditionalCommentsComponent
        additionalInformation={requirement.additionalInformation}
        onUpdate={updateAdditionalInfoState}
      />
    </div>
  );
}
